module.exports = __webpack_public_path__ + "img/33ss.28937c84.png";